import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, map } from 'rxjs';
import { environment } from '../../environments/environment';

export interface UserPreferencesPayload {
  idiomId: number;
  idiomTag: string;
  idiomLanguage: string;
  locale: string;
}

interface UserPreferencesApiResponse {
  payload: UserPreferencesPayload[];
}

@Injectable({ providedIn: 'root' })
export class UserPreferencesService {
  constructor(private readonly http: HttpClient) {}

  getUserPreferences(userId: number): Observable<UserPreferencesPayload> {
    return this.http
      .get<UserPreferencesApiResponse>(
        `${environment.URL_USER_PREFERENCES}/user-preferences/get?userId=${userId}`,
      )
      .pipe(map((res) => res.payload[0]));
  }
}
